import { useInstance } from 'intact-react';
import { useState } from '../../hooks/useState';
export function useFocus() {
  var instance = useInstance();
  var isFocus = useState(false);
  instance.on('focus', function () {
    return isFocus.set(true);
  });
  instance.on('blur', function () {
    return isFocus.set(false);
  });
  function focusInputOnClick(e) {
    instance.focus();
  }
  return {
    isFocus: isFocus,
    focusInputOnClick: focusInputOnClick
  };
}